import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Select from '../../../../../components/Select/index';
import 'parsleyjs';

class UserForm extends Component {
    componentDidMount() {
        let { userData, fetchAccountList } = this.props;
        if (userData.accountId) {
            fetchAccountList(userData.accountId);
        }
    }
    updateAddNewUserData = user => {
        let { updateUserData } = this.props;
        updateUserData(user);
    };

    handleInputChange = event => {
        let { userData, isEditable } = this.props;
        if (isEditable) {
            const target = event.target;
            const value =
                target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            let tmpSelected = _.extend({}, userData);
            tmpSelected[name] = value;
            this.updateAddNewUserData(tmpSelected);
        }
    };

    handleSelectChange = (name, value, valueKey) => {
        let { userData, fetchAccountList } = this.props;
        let tmpSelected = _.extend({}, userData);
        if (name === 'accountId') {
            if (value) {
                fetchAccountList(value[name]);
            } else {
                tmpSelected['clientId'] = '';
            }
        }
        if (value !== null) {
            if (valueKey) {
                tmpSelected[name] = value[valueKey];
            } else {
                tmpSelected[name] = value[name];
            }
        } else {
            tmpSelected[name] = '';
        }
        this.updateAddNewUserData(tmpSelected);
    };

    render() {
        let {
            userData,
            isEditable,
            disableEmail,
            accountList,
            clientList,
            roleList,
            formRef
        } = this.props;
        return (
            <form ref={formRef}>
                <div className="form-group col-md-12">
                    <label>Account</label>
                    <Select
                        name="accountId"
                        labelKey="name"
                        valueKey="accountId"
                        placeholder="Choose an Account"
                        selectedValue={userData.accountId}
                        onChange={this.handleSelectChange}
                        options={accountList}
                        disabled={!isEditable}
                        required={true}
                    />
                </div>
                <div className="form-group col-md-12">
                    <label>Client</label>
                    <Select
                        name="clientId"
                        labelKey="name"
                        valueKey="clientId"
                        placeholder="Choose a Client"
                        selectedValue={userData.clientId}
                        onChange={this.handleSelectChange}
                        options={clientList}
                        disabled={userData.accountId === '' || !isEditable}
                        required={true}
                    />
                </div>
                <div className="form-group col-md-6">
                    <label>First Name</label>
                    <input
                        className="form-control"
                        type="text"
                        name="firstName"
                        value={userData.firstName}
                        onChange={this.handleInputChange}
                        disabled={!isEditable}
                        data-parsley-required
                        data-parsley-maxlength="256"
                    />
                </div>
                <div className="form-group col-md-6">
                    <label>Last Name</label>
                    <input
                        className="form-control"
                        type="text"
                        name="lastName"
                        value={userData.lastName}
                        onChange={this.handleInputChange}
                        disabled={!isEditable}
                        data-parsley-required
                        data-parsley-maxlength="256"
                    />
                </div>
                <div className="form-group col-md-12">
                    <label>Email</label>
                    <input
                        className="form-control"
                        type="email"
                        name="email"
                        value={userData.email}
                        onChange={this.handleInputChange}
                        disabled={!isEditable || disableEmail}
                        data-parsley-required
                        data-parsley-maxlength="256"
                    />
                </div>
                <div className="form-group col-md-12">
                    <label>Password</label>
                    <input
                        className="form-control"
                        type="password"
                        name="password"
                        value={userData.password}
                        onChange={this.handleInputChange}
                        disabled={!isEditable}
                        data-parsley-required
                        data-parsley-maxlength="20"
                        data-parsley-minlength="6"
                    />
                </div>
                <div className="form-group col-md-12">
                    <label>Role</label>
                    <Select
                        name="roleName"
                        labelKey="name"
                        valueKey="roleName"
                        placeholder="Choose a Role"
                        selectedValue={userData.roleName}
                        onChange={this.handleSelectChange}
                        disabled={!isEditable}
                        options={roleList.map(role => ({
                            name: role,
                            roleName: role
                        }))}
                        required={true}
                    />
                </div>
            </form>
        );
    }
}

UserForm.propTypes = {
    userData: PropTypes.object.isRequired,
    accountList: PropTypes.array.isRequired,
    clientList: PropTypes.array.isRequired,
    roleList: PropTypes.array.isRequired,
    updateUserData: PropTypes.func,
    fetchAccountList: PropTypes.func,
    isEditable: PropTypes.func.bool,
    disableEmail: PropTypes.func.bool
};

UserForm.defaultProps = {
    isEditable: true,
    disableEmail: false
};

export default UserForm;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SignUp/components/UserForm.js